/** `location.state` key when navigating to success after POST 201. */
export const B2B_REGISTRATION_COMPLETE_STATE_KEY = 'b2bRegistrationComplete' as const;

export type B2bRegistrationLocationState = {
  readonly [B2B_REGISTRATION_COMPLETE_STATE_KEY]?: true;
};

export const isB2bRegistrationSuccessLocationState = (
  state: unknown,
): state is B2bRegistrationLocationState => {
  if (state == null || typeof state !== 'object') {
    return false;
  }
  return (state as B2bRegistrationLocationState)[B2B_REGISTRATION_COMPLETE_STATE_KEY] === true;
};
